import api from '@/services/Api';

class StoreService {
  async getAllAccountStore() {
    const response = await api.get('/distributor/store/all')
    return response.data
  }

  async getStoreWhiteListConfiguration(storeBoomerangId) {
    let encodedStoreBoomerangId = encodeURIComponent(storeBoomerangId)

    const response = await api.get('/distributor/store/whitelist-config/'
      + encodedStoreBoomerangId)
    return response.data
  }

  async getGuaranteeTransportManufacturerList(storeBoomerangId) {
    const response = await api.get(
      '/distributor/store/get-guarantee-transport-manufacturer-list/' + storeBoomerangId
    )
    return response.data
  }

  async getWithoutGuaranteeTransportManufacturerList(storeBoomerangId) {
    const response = await api.get(
      '/distributor/store/get-without-guarantee-transport-manufacturer-list/' + storeBoomerangId
    )
    return response.data
  }
}

export default new StoreService()
